import React from 'react';

const ProgressIcon = ({ status }) => {
  const displayIcon = (status) => {
    switch (status) {
      case 0:
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300">
            <path d="M150 0C67.29 0 0 67.29 0 150s67.29 150 150 150 150-67.29 150-150S232.71 0 150 0zm0 270c-66.169 0-120-53.832-120-120S83.831 30 150 30s120 53.832 120 120-53.832 120-120 120z" />
          </svg>
        );
      case 1:
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 285.919 285.919">
            <path d="M142.959 0C64.131 0 0 64.132 0 142.96s64.131 142.959 142.959 142.959 142.96-64.131 142.96-142.959S221.787 0 142.959 0zm0 260.919V25c65.043 0 117.96 52.917 117.96 117.96 0 65.043-52.917 117.959-117.96 117.959z" />
          </svg>
        );
      case 2:
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z" />
          </svg>
        );
    }
  };
  return <div className="progress-icon">{displayIcon(status)}</div>;
};

export default ProgressIcon;
